import { AlphabeticalGridItem } from 'components/alphabetical-grid-list';

type GroupedItems = {
  [key: string]: AlphabeticalGridItem[];
};

export const groupItemsByTitleFirstLetter = (
  items: Record<string, any>[],
): GroupedItems => {
  return items.reduce((acc, item) => {
    const firstLetter = item.title.charAt(0).toUpperCase();
    if (!acc[firstLetter]) {
      acc[firstLetter] = [];
    }
    acc[firstLetter].push(item);
    return acc;
  }, {} as GroupedItems);
};
